<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="validateForm()" class="btn fixed_btn">
        Save
      </button>

      <div class="card filters">
        <p class="title">Download Survey Results</p>
        <br />
        <br />
        <div>
          <button
            @click="filter_time = filter_dates.all"
            :class="{ active: filter_time == filter_dates.all }"
            class="btn round-btn"
          >
            All
          </button>
          <button
            @click="filter_time = filter_dates.today"
            :class="{ active: filter_time == filter_dates.today }"
            class="btn round-btn"
          >
            Today
          </button>
          <button
            @click="filter_time = filter_dates.yesterday"
            :class="{ active: filter_time == filter_dates.yesterday }"
            class="btn round-btn"
          >
            Since Yesterday
          </button>
          <button
            @click="filter_time = filter_dates.past_2_days"
            :class="{ active: filter_time == filter_dates.past_2_days }"
            class="btn round-btn"
          >
            Past 2 Days
          </button>
          <button
            @click="filter_time = filter_dates.past_week"
            :class="{ active: filter_time == filter_dates.past_week }"
            class="btn round-btn"
          >
            Past Week
          </button>
          <div class="filter">
            <datepicker
              placeholder="Start Date"
              v-model="custom_date.date"
              name="uniquename"
              ref="datepicker"
              :full-month-name="true"
              :disabled-dates="custom_date.disabled"
            ></datepicker>
          </div>
          <div class="filter">
            <datepicker
              placeholder="End Date"
              v-model="end_date"
              name="uniquename"
              ref="datepicker"
              :full-month-name="true"
              :disabled-dates="custom_date.disabled"
            ></datepicker>
          </div>
          <button @click="exportReport" class="btn active">
            Export
          </button>
        </div>
      </div>
      <div class="card">
        <p class="title">Survey Delivery Time</p>
        <div class="inputs">
          <div class="survey-time input full">
            <div class="dates">
              <select v-model.number="reminder_hour">
                <option v-for="n in 12" :key="n" :value="n">{{
                  `${n}`.padStart(2, 0)
                }}</option>
              </select>
              <select v-model.number="reminder_minute">
                <option v-for="n in 60" :key="n" :value="n - 1">{{
                  `${n - 1}`.padStart(2, 0)
                }}</option>
              </select>
              <select v-model="reminder_ampm">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <p class="title">Account Information</p>

        <div class="inputs">
          <div class="input">
            <label>Email</label>
            <input
              @change="emailChanged = true"
              @keyup="edit_init = true"
              v-model="employer.email"
            />
          </div>
          <div v-if="changePassword" class="inputs">
            <div class="input">
              <label>Password</label>
              <input @keyup="edit_init = true" v-model="newPassword" />
            </div>
          </div>
        </div>
        <div class="btns left">
          <button class="btn" @click="changePassword = !changePassword">
            {{ !changePassword ? "Change Password" : "Cancel" }}
          </button>
          <button class="btn round-btn" @click="saveAccountInfo">Save</button>
        </div>
      </div>
      <div class="card">
        <p class="title">Profile</p>
        <div class="inputs">
          <div class="input">
            <label>Company's Name</label>
            <input @keyup="edit_init = true" v-model="employer.company" />
          </div>
          <div class="input">
            <label>Employer's Name</label>
            <input @keyup="edit_init = true" v-model="employer.name" />
          </div>

          <div class="input full">
            <label
              >Reports Email Digest
              <span
                class="help-icon"
                @mouseover="helper = true"
                @mouseout="helper = false"
                >?</span
              >
            </label>
            <transition name="fade">
              <p v-if="helper" class="helper">
                Would you like to subscribe to either a daily or weekly report
                email digest?
              </p>
            </transition>
            <div class="switch-holder">
              <span style="margin-right: 15px">{{
                employer.email_digest.on ? "On" : "Off"
              }}</span>
              <switches v-model="employer.email_digest.on"></switches>
            </div>
            <div class="input">
              <v-select
                class="input"
                v-model="employer.email_digest.option"
                :clearable="false"
                :options="['Daily', 'Weekly']"
              >
              </v-select>
            </div>
            <div class="input full">
              <label>CC Additional Users (Optional)</label>
              <div class="input-data" @click="$refs.emailAdder.focus()">
                <div
                  class="email"
                  v-for="(user, index) in employer.email_digest
                    .additional_users"
                  :key="user"
                >
                  {{ user }}
                  <span
                    style="color:red; cursor:pointer"
                    @click="removeUser(index)"
                    >x</span
                  >
                </div>
                <div class="input-email-holder">
                  <input
                    ref="emailAdder"
                    placeholder="Type an email here"
                    type="email"
                    v-model="cc_email"
                    @keydown="checkIfEmail"
                    @input="checkIfEmail"
                  />
                  <button
                    v-if="show_email_add"
                    @click="addAdditionalUsers"
                    class="btn round-btn"
                  >
                    add email
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="input full">
            <label>Company Logo</label>
            <file-upload
              @removeImage="employer.logo = null"
              @uploadImage="uploadImage"
              :media="employer.logo"
              directory="Company Logo"
            />
          </div>
          <div class="input">
            <label>Company Primary Color</label>
            <div class="color-input">
              <span>#</span>
              <input v-model="employer.color" placeholder="000000" />
              <div
                class="company-color"
                :style="{ backgroundColor: '#' + employer.color }"
              ></div>
            </div>
          </div>
          <!-- <div class="input">
            <label>Company Fonts <span class="type">.woff files</span></label>
            <div class="fonts">
              <input
                ref="upload"
                type="file"
                accept=".woff"
                multiple
                class="hide_upload"
                @change="uploadFonts"
              />
              <div class="add-font" @click="$refs.upload.click()">
                Add Font
                <img src="@/assets/img/add.svg" />
              </div>
              <div v-for="(font, i) in employer.fonts" class="font">
                {{ font.font_name }}
                <div class="remove-font" @click="removeFont(i)">
                  x
                </div>
              </div>
            </div>
          </div> -->
          <div class="btns left">
            <button @click="validateForm()" class="btn round-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
import Switches from "vue-switches";
import Datepicker from "vuejs-datepicker";
import { db, storage, functions, auth } from "../firebaseConfig.js";
import moment from "moment-timezone";

export default {
  name: "employer",
  components: {
    Switches,
    Datepicker,
  },
  data() {
    return {
      emailChanged: false,
      changePassword: false,
      end_date: new Date(),
      employer: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        // fonts: [],
        email_digest: { option: "Daily", on: true, additional_users: [] },
      },
      color: "00bf6f",
      fonts: [],
      cc_email: null,
      show_email_add: false,
      helper: false,
      edit_init: false,
      newPassword: null,
      custom_date: {
        date: null,
        disabled: {
          from: new Date(),
        },
      },
      filter_dates: {
        all: null,
        today: moment()
          .startOf("day")
          .valueOf(),
        yesterday: moment()
          .subtract(1, "day")
          .startOf("day")
          .valueOf(),
        past_2_days: moment()
          .subtract(2, "days")
          .startOf("day")
          .valueOf(),
        past_week: moment()
          .subtract(1, "week")
          .startOf("day")
          .valueOf(),
      },
    };
  },
  created() {
    db.collection("user")
      .doc(this.user_doc.id)
      .get()
      .then((res) => {
        this.employer = Object.assign(
          {
            id: res.id,
            email_digest: res.data().hasOwnProperty("email_digest")
              ? res.data().email_digest
              : { option: "Daily", on: true, additional_users: [] },
          },
          res.data()
        );
      });
  },
  methods: {
    saveAccountInfo() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      if (this.emailChanged || this.newPassword) {
        let payload = {};
        if (this.emailChanged) payload.email = this.employer.email;
        if (this.newPassword) payload.password = this.newPassword;
        functions
          .httpsCallable("auth-updateUserAuth")({
            uid: this.employer.id,
            payload: payload,
          })
          .then((res) => {
            return db
              .doc(`user/${this.employer.id}`)
              .update({
                email: this.employer.email,
              })
              .catch((err) => {
                console.log(err);
                throw err;
              });
          })
          .then((res) => {
            loader.hide();
            this.emailChanged = false;
            this.changePassword = false;
            this.newPassword = null;
            return Swal.fire(
              "",
              "Account information succesfully updated",
              "success"
            );
          })
          .catch((err) => {
            loader.hide();
            console.log(err);
            return Swal.fire(
              "Error: ",
              `${err.message}. Please try again later or contact administrator at info@popshap.com`,
              "error"
            );
          });
      }
    },
    exportReport() {
      window.open(
        `https://us-central1-covid19pad-672e5.cloudfunctions.net/reporting-exportFull?uid=${
          this.user_doc.id
        }&start_date=${moment(this.filter_time).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(this.end_date).format(
          "YYYY-MM-DD"
        )}&limit=0&page=1`,
        "_blank"
      );
    },
    validateForm() {
      this.saveEmployer();
    },
    uploadImage(payload) {
      this.employer.logo = payload.url;
      this.edit_init = true;
    },
    saveEmployer() {
      this.employer.color = this.color;
      if (this.fonts.length) this.employer.fonts = this.fonts;
      db.collection("user")
        .doc(this.user_doc.id)
        .set(this.employer, { merge: true })
        .then(() => {
          this.edit_init = false;
          Swal.fire("Profile Saved");
        })
        .catch((err) => {
          Swal.fire("Error");
        });
    },
    checkIfEmail(e) {
      let val = e.target.value;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(val.toLowerCase())) {
        if (e.keyCode == 13) {
          this.addAdditionalUsers();
        } else {
          this.show_email_add = true;
        }
      } else {
        this.show_email_add = false;
      }
    },
    addAdditionalUsers() {
      if (this.cc_email) {
        this.edit_init = true;
        let val = this.cc_email
          .split(",")
          .map((v) => v.trim())
          .filter((v) => this.validateEmail(v));
        if (!this.employer.email_digest.additional_users) {
          this.employer.email_digest.additional_users = [];
        }
        this.employer.email_digest.additional_users = [].concat(
          this.employer.email_digest.additional_users,
          val
        );
      }
      this.cc_email = null;
      this.show_email_add = false;
    },
    removeUser(index) {
      this.edit_init = true;
      this.employer.email_digest.additional_users.splice(index, 1);
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    uploadFonts(e) {
      let vm = this;
      this.font = null;
      let fonts = e.target.files;
      Array.from(fonts).forEach((font) => {
        let fontName = font.name;
        let type = font.type;
        let reader = new FileReader();

        reader.readAsDataURL(font);
        reader.onload = (e) => {
          let storageRef = storage.ref(`fonts/${fontName}}`);
          let uploadTask = storageRef.put(font);
          let blob = e.target.result;

          uploadTask.on(
            "state_changed",
            (snapshot) => {},
            (error) => {
              vm.logoLoad = false;
              Swal.fire("could not upload font, please try again.");
            },
            (snapshot) => {
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                this.employer.fonts.push({
                  font_name: fontName,
                  url: downloadURL,
                });
                this.fonts.push({
                  font_name: fontName,
                  url: downloadURL,
                });
              });
            }
          );
        };
      });
    },
    removeFont(i) {
      this.fonts.splice(i, 1);
    },
    formatHour(hour) {
      if (this.reminder_ampm === "PM") {
        return hour + 12;
      } else if (this.reminder_ampm === "AM") {
        if (hour == 12) {
          return 0;
        }
      }
      return hour;
    },
  },
  computed: {
    filter_time: {
      get() {
        if (this.custom_date.date) {
          return moment(this.custom_date.date).valueOf();
        } else {
          return null;
        }
      },
      set(val) {
        if (val == null) {
          this.custom_date.date = null;
        } else {
          this.custom_date.date = new Date(val);
        }
      },
    },
    reminder_hour: {
      get() {
        let r_time = {
          hour: 3,
          minute: 30,
          ampm: "AM",
        };
        if (this.employer.reminder_time) {
          const curr_time = `${this.employer.reminder_time}`.padStart(4, 0);
          let hour = parseInt(curr_time.substring(0, 2));
          let minute = parseInt(curr_time.substring(2));
          let ampm = parseInt(hour) >= 12 ? "PM" : "AM";
          if (ampm === "PM") {
            if (hour > 12) {
              hour -= 12;
            }
          } else {
            if (hour == 0) {
              hour = 12;
            }
          }
          Object.assign(r_time, { hour, minute, ampm });
        }
        return r_time.hour;
      },
      set(val) {
        this.employer = Object.assign({}, this.employer, {
          reminder_time: parseInt(
            `${this.formatHour(val)}${this.reminder_minute}`
          ),
        });
      },
    },
    reminder_minute: {
      get() {
        let r_time = {
          hour: 3,
          minute: 30,
          ampm: "AM",
        };
        if (this.employer.reminder_time) {
          const curr_time = `${this.employer.reminder_time}`.padStart(4, 0);
          let hour = parseInt(curr_time.substring(0, 2));
          let minute = parseInt(curr_time.substring(2));
          let ampm = parseInt(hour) >= 12 ? "PM" : "AM";
          Object.assign(r_time, { hour, minute, ampm });
        }
        return r_time.minute;
      },
      set(val) {
        let r_time = {
          hour: 3,
          minute: 30,
        };
        if (this.employer.reminder_time) {
          const curr_time = `${this.employer.reminder_time}`.padStart(4, 0);
          let hour = parseInt(curr_time.substring(0, 2));
          let minute = `${val}`.padStart(2, 0);
          Object.assign(r_time, { hour, minute });
        }

        Object.assign(r_time, { minute: `${val}`.padStart(2, 0) });

        this.employer = Object.assign({}, this.employer, {
          reminder_time: parseInt(`${r_time.hour}${r_time.minute}`),
        });
      },
    },
    reminder_ampm: {
      get() {
        let r_time = {
          hour: 3,
          minute: 30,
          ampm: "AM",
        };
        if (this.employer.reminder_time) {
          const curr_time = `${this.employer.reminder_time}`.padStart(4, 0);
          let hour = parseInt(curr_time.substring(0, 2));
          let minute = parseInt(curr_time.substring(2));
          let ampm = parseInt(hour) >= 12 && parseInt(hour) != 0 ? "PM" : "AM";
          Object.assign(r_time, { hour, minute, ampm });
        }
        return r_time.ampm;
      },
      set(val) {
        let hour = this.reminder_hour;
        if (val === "AM") {
          if (hour > 12) {
            hour -= 12;
          } else if (hour == 12) {
            hour = 0;
          }
        } else {
          if (hour < 12) {
            hour += 12;
          }
        }
        this.employer = Object.assign({}, this.employer, {
          reminder_time: parseInt(`${hour}${this.reminder_minute}`),
        });
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.edit_init) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>

<style scoped lang="scss">
.totals {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
  p {
    margin-left: 40px;
    font-size: 15px;
    span {
      font-size: 35px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
    }
  }
}
h3 {
  margin-top: 30px;
}

.text_btn {
  text-decoration: underline;
}

.input-btn {
  display: flex;
  align-items: center;
  input {
    width: 100%;
  }
  .btn {
    flex: none;
    padding-top: 0;
  }
}

.add-answer {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 2px solid #eaeaea;
}

.answers {
  input {
    margin-bottom: 6px !important;
    padding: 5px 15px !important;
    font-size: 15px !important;
  }
}

.add-question {
  margin-top: 30px;
}

h4 {
  margin-top: 0;
  font-weight: 500;
  span {
    display: block;
    font-size: 25px;
    margin-top: 5px;
    font-weight: bold;
  }
}

.question {
  padding: 15px 30px !important;
  position: relative;
  ul {
    margin-bottom: 0;
  }
  .controls {
    display: flex;
    position: absolute;
    right: 20px;
    top: 20px;
    align-items: center;
    img {
      height: 30px;
      margin-left: 20px;
      cursor: pointer;
    }
  }
}

.full .v-select {
  margin-bottom: 15px;
}

.input-data {
  background-color: #eaeaea;
  font-size: 17px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 15px;
  input {
    width: 100%;
    background: transparent;
    margin-bottom: 0;
  }
  .email {
    padding: 5px 10px;
    background-color: white;
    border-radius: 10px;
    margin: 10px 15px;
    margin-bottom: 0;
    margin-right: 0;
  }
}

.input-email-holder {
  display: flex;
  align-items: flex-start;
  width: 100%;
  flex-direction: column;
  .btn {
    padding: 5px 10px;
    width: auto;
    font-size: 13px !important;
    width: auto;
    margin: 10px;
    margin-top: 0;
  }
}

.color-input {
  display: flex;
  position: relative;
  align-items: center;
  input {
    padding-left: 30px;
  }
  span {
    position: absolute;
    left: 15px;
    margin-top: -15px;
  }
  .company-color {
    height: 25px;
    width: 25px;
    margin-left: 10px;
    position: absolute;
    right: 10px;
    margin-top: -13px;
    z-index: 2;
  }
}

.fonts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .add-font,
  .font {
    cursor: pointer;
    background: #eaeaea;
    padding: 10px;
    display: flex;
    font-size: 15px;
    margin-right: 10px;
    margin-bottom: 10px;
    align-items: center;
    width: 120px;
    justify-content: center;
    img {
      margin-left: 10px;
      height: 20px;
      cursor: pointer;
    }
  }
  .font {
    width: auto;
    .remove-font {
      height: 20px;
      width: 20px;
      background: white;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      margin-left: 10px;
      color: #f44336;
    }
  }
}

.filters {
  display: flex;
  align-items: center;
  padding: 10px;
  padding-bottom: 0;
  .btn {
    margin-right: 10px;
    margin-bottom: 10px;
    transition: box-shadow 0.3s;
    background: #eaeaea;
    color: #767676;
    padding: 10px 20px;
    font-size: 13px;
    text-transform: uppercase;
    &.active {
      background-color: #00d97e;
      color: white;
    }
  }
  .filter {
    margin-right: 10px;
    margin-bottom: 10px;
    & > label {
      margin-bottom: 0;
      position: relative;
      top: 4px;
    }
  }
}

.hide_upload {
  position: absolute;
  z-index: -2;
  width: 0 !important;
}

.type {
  font-weight: normal;
  margin-left: 5px;
}

.survey-time .dates select {
  width: 80px;
  margin-right: 10px;
}
</style>
